export const CHART_COLORS = {
  primary: 'rgb(61, 14, 117)',
  primaryLight: 'rgb(136, 80, 219)',
}
